'use client'

import { analytics } from '@/core/analytics/google-analytics'
import { useReportWebVitals } from 'next/web-vitals'

export function WebVitals() {
  useReportWebVitals(metric => {
    analytics.trackEvent(metric.name, {
      value: Math.round(
        metric.name === 'CLS' ? metric.value * 1000 : metric.value,
      ),
      event_label: metric.id,
      non_interaction: true,
    })
  })

  return null
}
